var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bindable } from "aurelia-templating";
import { transient } from "aurelia-dependency-injection";
import { autoinject, noView } from "aurelia-framework";
import { RowItem } from "./data-grid";
var CellLifeCycleListenerCustomAttribute = /** @class */ (function () {
    function CellLifeCycleListenerCustomAttribute() {
    }
    CellLifeCycleListenerCustomAttribute.prototype.rowItemChanged = function (newValue, oldValue) {
        if (oldValue && oldValue.onUnloaded) {
            oldValue.onUnloaded();
        }
    };
    CellLifeCycleListenerCustomAttribute.prototype.detached = function () {
        if (this.rowItem && this.rowItem.onUnloaded) {
            this.rowItem.onUnloaded();
        }
    };
    __decorate([
        bindable,
        __metadata("design:type", RowItem)
    ], CellLifeCycleListenerCustomAttribute.prototype, "rowItem", void 0);
    CellLifeCycleListenerCustomAttribute = __decorate([
        noView(),
        autoinject(),
        transient()
    ], CellLifeCycleListenerCustomAttribute);
    return CellLifeCycleListenerCustomAttribute;
}());
export { CellLifeCycleListenerCustomAttribute };
